<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <form @submit.prevent="saveStatus">
      <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
        <div class="md:flex md:items-center md:justify-between">
          <div class="flex min-w-0">
            <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
            <h1 class="content-title">
              {{ $t('New repair status') }}
            </h1>
          </div>
          <div class="mt-4 flex md:mt-0 md:ml-4">
            <router-link class="btn btn-app" to="/admin/repair-statuses">
              {{ $t('Back') }}
            </router-link>
          </div>
        </div>
      </div>
      <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8 ">
        <div class="content-card-body">
          <loading :status="loading"></loading>
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Repair status details') }}
              </h3>
              <p class="form-description-text">{{ $t('Repair status details and customization') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-6">
                <div class="col-span-3">
                  <label class="form-label" for="body">{{ $t('Body') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Body')" class="form-input" id="body" required v-model="status.body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <span class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/repair-statuses">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Save') }}
              </button>
            </span>
          </div>
        </div>
      </div>
    </form>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('New status'),
    };
  },
  data() {
    return {
      loading: false,
      status: {
        body: null,
      },
    };
  },
  methods: {
    saveStatus() {
      this.loading = true;
      axios
        .post(route('repair-statuses.store'), this.status)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/admin/repair-statuses/${response.data.status.id}/edit`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
